import * as React from "react";
import { Anchor } from "../typography/anchor/anchor.mjs";
import { Icon } from "../icon/icon/icon.mjs";
import { Image } from "../image/image.mjs";
import { Spinner } from "../spinner/spinner.mjs";
function isSuggestionGroup(item) {
  return Object.prototype.hasOwnProperty.call(item, "items");
}
class Suggestion extends React.PureComponent {
  BEM() {
    const classArray = ["suggestion"];
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  itemBEM(item) {
    const classArray = ["suggestion__item"];
    if (isSuggestionGroup(item)) {
      classArray.push("suggestion__item--grouped");
    } else {
      if (item.isActive) {
        classArray.push("is-active");
      }
      if (item.isFocused) {
        classArray.push("is-focused");
      }
      if (item.color) {
        classArray.push("suggestion__item--" + item.color);
      }
      if (item.className) {
        classArray.push(item.className);
      }
    }
    return classArray.join(" ");
  }
  // Don't remove spans, they are needed if the page is translated with Google Translate
  getMarkedContent(label) {
    return /* @__PURE__ */ React.createElement("mark", { className: "suggestion__label-mark" }, /* @__PURE__ */ React.createElement("span", null, label));
  }
  // Don't remove spans, they are needed if the page is translated with Google Translate
  generateLabel(item) {
    const { label, subLabel } = item;
    const { highlightedValue } = this.props;
    const getSubLabel = subLabel && /* @__PURE__ */ React.createElement("span", { className: "suggestion__sub-label" }, subLabel);
    if (highlightedValue) {
      const highlightedValueIndex = label.toLowerCase().indexOf(highlightedValue.toLowerCase());
      const highlightedText = label.slice(highlightedValueIndex, highlightedValueIndex + highlightedValue.length);
      if (label.toLowerCase().includes(highlightedValue.toLowerCase())) {
        const markedLabel = label.split(highlightedText).map((part, index) => {
          return /* @__PURE__ */ React.createElement(React.Fragment, { key: "".concat(item.id, "-").concat(index) }, /* @__PURE__ */ React.createElement("span", null, part.split(highlightedText)[0]), label.split(highlightedText).length !== index + 1 && this.getMarkedContent(highlightedText));
        });
        return /* @__PURE__ */ React.createElement("span", { className: "suggestion__label" }, /* @__PURE__ */ React.createElement("span", null, markedLabel), /* @__PURE__ */ React.createElement("span", null, getSubLabel));
      }
    }
    return /* @__PURE__ */ React.createElement("span", { className: "suggestion__label" }, /* @__PURE__ */ React.createElement("span", null, label), /* @__PURE__ */ React.createElement("span", null, getSubLabel));
  }
  getItem(item, index) {
    const { label, subLabel, isActive, itemRef, icon, image, id, role, "aria-selected": ariaSelected, isFocused, ...rest } = item;
    return /* @__PURE__ */ React.createElement("li", { className: this.itemBEM(item), ref: itemRef, key: id != null ? id : index, role, "aria-selected": ariaSelected, id }, /* @__PURE__ */ React.createElement(Anchor, { isUnderlined: false, tabIndex: 0, ...rest, className: "suggestion__link" }, icon && /* @__PURE__ */ React.createElement(Icon, { modifiers: icon, className: "suggestion__icon" }), image && /* @__PURE__ */ React.createElement(Image, { ...image, className: "suggestion__image" }), this.generateLabel(item)));
  }
  getItems(items) {
    return items.map((item, index) => {
      var _a;
      if (isSuggestionGroup(item)) {
        return /* @__PURE__ */ React.createElement("li", { className: this.itemBEM(item), key: (_a = item.id) != null ? _a : index }, /* @__PURE__ */ React.createElement("div", { className: "suggestion__group-label" }, item.label), /* @__PURE__ */ React.createElement("ul", { className: "suggestion__group-list" }, item.items.map((groupListItem, i) => {
          return this.getItem(groupListItem, i);
        })));
      } else {
        return this.getItem(item, index);
      }
    });
  }
  getAdditionalContent(additionalContent) {
    return /* @__PURE__ */ React.createElement("li", { className: "suggestion__item suggestion__item--additional-content", role: "none" }, additionalContent);
  }
  getSpinner() {
    return /* @__PURE__ */ React.createElement("li", { className: "suggestion__item", role: "none" }, /* @__PURE__ */ React.createElement(Spinner, { className: "suggestion__spinner" }));
  }
  renderNoResultsMessage(noResultsMessage) {
    return /* @__PURE__ */ React.createElement("li", { className: "suggestion__item suggestion__item--no-results-message", role: "none" }, noResultsMessage);
  }
  render() {
    const { items, listRef, isLoading, highlightedValue, additionalContent, noResultsMessage, ...rest } = this.props;
    return /* @__PURE__ */ React.createElement("ul", { ...rest, ref: listRef, className: this.BEM() }, noResultsMessage ? this.renderNoResultsMessage(noResultsMessage) : /* @__PURE__ */ React.createElement(React.Fragment, null, this.getItems(items), isLoading && this.getSpinner(), additionalContent && this.getAdditionalContent(additionalContent)));
  }
}
export {
  Suggestion,
  isSuggestionGroup
};
